module.exports = __webpack_public_path__ + "static/media/holding_egg.566e0bae.gif";